"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var InstructorCourseController = /** @class */ (function () {
    function InstructorCourseController() {
    }
    return InstructorCourseController;
}());
InstructorCourseController.$inject = [];
exports.default = InstructorCourseController;
